/* eslint-disable react/jsx-props-no-spreading */
import { Provider } from 'react-redux';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from 'redux/store';
import { MatchJobListScreen } from './screens/MatchJobListScreen';
import { getServerSideProps } from './getServerSideProps';

/**
 * サーバーサイドレンダリング用のプロパティ取得関数
 */
export { getServerSideProps };

/**
 * アプリケーションのエントリーポイントとなるコンポーネント
 *
 * @param {InferGetServerSidePropsType<typeof getServerSideProps>} props - Next.jsのアプリケーションプロパティ（Componentを除く）
 * @returns {JSX.Element} - アプリケーションのルートコンポーネント
 */
export default function Index(
  props: InferGetServerSidePropsType<typeof getServerSideProps>
): JSX.Element {
  const { initialState, ...pageProps } = props;
  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <MatchJobListScreen {...pageProps} />
    </Provider>
  );
}
